export default "__VITE_ASSET__379569cc__"